import { render } from "./ERInputs.vue?vue&type=template&id=246cc4bb"
import script from "./ERInputs.vue?vue&type=script&lang=js"
export * from "./ERInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__